import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getScopeName, getViewName } from '../../utils/nameFormat';
export const removeScopeStmtInstruction = `
#### Remove scope
Removes a scope from a view.

- Syntax: \`remove scope <scope_name> from <view_name>;\`
- Example: \`remove scope ${getScopeName({ entityName: 'PackageReservation' })} from ${getViewName({
    entityName: 'PackageReservation',
    viewType: 'detail',
})};\`
`;
export const stmtRemoveScope = ({ scopeName, viewName }) => {
    return `remove scope ${scopeName}${viewName ? ` from ${viewName}` : ''};`;
};
export const removeScopeHandler = createStructureStatementHandler({
    type: 'remove scope',
    parse: line => {
        const match = /^remove scope (?<scopeName>\w+)( from (?<viewName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove scope',
                scopeName: match.groups.scopeName,
                viewName: match.groups.viewName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.removeScope({
        scopeName: stmt.scopeName,
        viewName: stmt.viewName,
    })),
});
//# sourceMappingURL=RemoveScopeStmt.js.map